//================================================================
//  Page: Total Contract Value 
//================================================================

//  Purpose: Contains table to add, edit and calculate contract values in a request

//  Properties:
//    - task = { useState, stores the currently selected request}
//    - view = { string, used to determine if the table is read only or editable}

//  Example:
//  
//    <TotalContractValue
//     task={task}
//     view={'read'}
//    ></TotalContractValue>

//================================================================

//Libraries
import React from 'react';

//Contexts

//Components
import KebabDropdown from '../KebabDropdown/KebabDropdown';

//Functions

//Images
import AddIconDisabled from '../Images/Icon_Add_Grey.svg';

//CSS


export default function TotalContractValue({
    task,
    view
}) {

    //------------------------------------------------------
    //  Functions
    //------------------------------------------------------

    // Calculate total cost
    const getTotalContractValue = () => {

        let value = 0;

        task?.costs?.forEach((cost) => {
            // One-time cost
            if (cost.costtype === 'One-time')
                value += cost?.costperterm
            // Monthly or Yearly cost
            else
                value += cost?.costperterm * cost?.terms
        });

        return value;
    };

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='Table-Container flex flex-col w-full h-full overflow-hidden'>

            <div className='w-full overflow-x-auto'>

                <table className='w-full '>
                    <thead>
                        <tr className='text-[#424242] border-b-2 border-b-[#D8D8D8]'>
                            <th className='py-[15px] px-4 font-medium'>Description</th>
                            <th className='py-[15px] px-4 font-medium'>Cost per Term (exTax)</th>
                            <th className='py-[15px] px-4 font-medium'>Terms</th>
                            <th className='py-[15px] px-4 font-medium'>Term Type</th>
                            <th className='py-[15px] px-4 font-medium'>Total (exTax)</th>
                            <th className='py-[15px] px-4 font-medium'>Currency</th>
                            <th className='py-[15px] w-10' hidden={view === 'read'}>
                                <img
                                    src={AddIconDisabled}
                                    alt='Add'
                                    className={!task?.sentfinalapprovals && 'cursor-pointer'}
                                >
                                </img>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            // No Costs found
                            task?.costs?.length === 0 || task?.costs === undefined ?
                                (
                                    <tr>
                                        <td colSpan={view === 'read' ? 4 : 5}>
                                            <div className='text-center p-[2%]'>
                                                Click on the '+' to add costs
                                            </div>
                                        </td>
                                    </tr>
                                )
                                :
                                (
                                    // Map in each Cost
                                    task?.costs?.map((cost) => (
                                        <tr key={cost?.costid} className='border-b border-b-[#D8D8D8]'>
                                            <td className='py-[15px] px-4'>{cost?.description}</td>
                                            <td className='py-[15px] px-4'>{isNaN(cost?.costperterm) ? cost?.onetimecost.toLocaleString() : cost?.costperterm.toLocaleString()}</td>
                                            <td className='py-[15px] px-4'>{cost?.terms < 1 ? '--' : cost?.terms}</td>
                                            <td className='py-[15px] px-4'>{cost?.costtype}</td>
                                            <td className='py-[15px] px-4'>{(cost?.costtype === 'Monthly' || cost?.costtype === 'Yearly') ? (cost?.costperterm * cost?.terms).toLocaleString() : cost?.costperterm.toLocaleString()}</td>
                                            <td className='py-[15px] px-4'>AUD</td>
                                            <td className='py-[15px] w-10' hidden={view === 'read'}>
                                                <KebabDropdown
                                                    children={
                                                        <div className=' bg-white rounded shadow-lg z-10'>
                                                            <button
                                                                className={`block w-full text-left px-4 py-2 ${task?.sentfinalapprovals ? 'text-gray-200' : 'text-gray-700 hover:bg-gray-100'}`}
                                                                disabled={task?.sentfinalapprovals ? true : false}
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                className={`block w-full text-left px-4 py-2 ${task?.sentfinalapprovals ? 'text-red-200' : 'text-red-600 hover:bg-gray-100'}`}
                                                                disabled={task?.sentfinalapprovals ? true : false}
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    }
                                                ></KebabDropdown>
                                            </td>
                                        </tr>
                                    ))
                                )
                        }

                        {/* Total Contract Value */}
                        <tr className='py-[15px] px-[5px]' hidden={task?.costs?.length < 1}>
                            <td className='py-[15px] px-4 text-right' colSpan={6}>
                                <div className='flex flex-row gap-2 items-center justify-end'>
                                    <p className='mb-0'>Total Contract Value (exTax):</p>
                                    <p className='font-semibold mb-0'>{getTotalContractValue().toLocaleString()} AUD</p>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    )
}